module.exports = __webpack_public_path__ + "img/3.740d0163.jpg";